import React from 'react'
import useAvailableRedemptions from './use-available-redemptions'

const AvailableIOSRedemptions = () => {
    const { isLoading, availableRedemptions } = useAvailableRedemptions()

    if (isLoading) {
        return null
    }

    return (
        <React.Fragment>
            {availableRedemptions}
        </React.Fragment>
    )
}

export default AvailableIOSRedemptions
